import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table   : 'CI_PSET',
    fieldMap: {
        id              : 'CIPS_ID',
        statusId        : 'CIPS_CIST_ID',
        origin          : 'CIPS_ORIGIN',
        module          : 'CIPS_MODULE',
        itemTypeId      : 'CIPS_CIT_ID',
        propertyTypeId  : 'CIPS_CIPT_ID',
        valueSetId      : 'CIPS_CIVS_ID',
        description     : 'CIPS_DESCRIPTION',
        keyType         : 'CIPS_KEY_TYPE',
        keyDefinition   : 'CIPS_KEY_DEFINITION',
        keyExample      : 'CIPS_KEY_EXAMPLE',
        valueType       : 'CIPS_VALUE_TYPE',
        valueDefinition : 'CIPS_VALUE_DEFINITION',
        valueExample    : 'CIPS_VALUE_EXAMPLE',
        valueDefault    : 'CIPS_VALUE_DEFAULT',
        valueMin        : 'CIPS_VALUE_MIN',
        valueMax        : 'CIPS_VALUE_MAX',
        valueUnit       : 'CIPS_VALUE_UNIT',
        isEnumerated    : 'CIPS_IS_ENUMERATED',
        isImported      : 'CIPS_IS_IMPORTED',
        modifierUserId  : 'CIPS_MODIFIER',
        modificationTime: 'CIPS_MODIFICATION_TIME',
        uuid            : 'CIPS_UUID'
    }
};

export default tableDefinition;
